import React from 'react';
import PropTypes from 'prop-types';

const IconArrow = ({
  width, height, bgCircle, bgArrow, specialClass,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 32 32"
    fill={bgCircle}
    xmlns="http://www.w3.org/2000/svg"
    className={specialClass}
  >
    <g clipPath="url(#clip0_85_4274)">
      <circle cx={16} cy={16} r={15} stroke="#4F4FFF" strokeWidth={2} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.1513 11.1513C13.6199 10.6826 14.3797 10.6826 14.8483 11.1513L18.8483 15.1513C19.317 15.6199 19.317 16.3797 18.8483 16.8483L14.8483 20.8483C14.3797 21.317 13.6199 21.317 13.1513 20.8483C12.6826 20.3797 12.6826 19.6199 13.1513 19.1513L16.3027 15.9998L13.1513 12.8483C12.6826 12.3797 12.6826 11.6199 13.1513 11.1513Z"
        fill={bgArrow}
      />
    </g>
    <defs>
      <clipPath id="clip0_85_4274">
        <rect width={width} height={height} fill="white" />
      </clipPath>
    </defs>
  </svg>
);

IconArrow.defaultProps = {
  width: 32,
  height: 32,
  bgCircle: 'none',
  bgArrow: '#4F4FFF',
  specialClass: '',
};

IconArrow.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  bgCircle: PropTypes.string,
  bgArrow: PropTypes.string,
  specialClass: PropTypes.string,
};

export default IconArrow;
